import api from '../services/api';

// TR-S3 — management project-reports API client. The shared axios instance's
// response interceptor unwraps `.data`, so each call resolves to the payload.

export const getAllProjectsReview = (status = 'Active', period = 'ProjectToDate') =>
  api.get('/reports/projects', { params: { status, period } });

export const getProjectBreakdown = (projectId, period = 'ProjectToDate') =>
  api.get(`/reports/projects/${projectId}/breakdown`, { params: { period } });

export const getProjectTasksReview = (projectId, phaseId = null, leafOnly = true) =>
  api.get(`/reports/projects/${projectId}/tasks`, {
    params: { phaseId: phaseId ?? undefined, leafOnly },
  });

// RA-S4 — Project Consumption (role-budget view). Returns the full
// phase → task → WI tree + BillableWiWithoutRole. The xlsx URL is a
// separate route the client hits directly via <a download> so the
// browser handles the file save without axios buffering.
export const getProjectConsumption = (projectId) =>
  api.get(`/reports/project-consumption/${projectId}`);
export const projectConsumptionXlsxUrl = (projectId) =>
  api.getUri
    ? api.getUri({ url: `/reports/project-consumption/${projectId}/xlsx` })
    : `/api/reports/project-consumption/${projectId}/xlsx`;

// TR-S4 — team views.
export const getTeamUtilization = (year, month, teamId = null) =>
  api.get('/reports/team-utilization', { params: { year, month, teamId: teamId ?? undefined } });

export const getTeamCalendar = (year, month, teamId = null) =>
  api.get('/reports/team-calendar', { params: { year, month, teamId: teamId ?? undefined } });

// TC-S1 — arbitrary-window Team Calendar for the reworked overview page.
// `fromIso` and `toIso` are expected to be "yyyy-MM-dd" local calendar
// strings (built via the same fmtIso helper the page uses); no UTC
// conversion happens on either side. Server enforces max 62 days.
export const getTeamCalendarRange = (fromIso, toIso, teamId = null) =>
  api.get('/reports/team-calendar/range', {
    params: { from: fromIso, to: toIso, teamId: teamId ?? undefined },
  });

// TC-S2 — docked consultant panel.
// `getConsultantCalendar` drives the m/w cells (same shape as
// team-calendar/range but scoped to one consultant, max 62 days).
// `getConsultantDays` drives the typed day view (Task/Project/
// ShortLeave/Leave entries; note redaction is server-side).
export const getConsultantCalendar = (employeeId, fromIso, toIso) =>
  api.get('/reports/consultant-calendar', {
    params: { employeeId, from: fromIso, to: toIso },
  });

export const getConsultantDays = (employeeId, fromIso, toIso) =>
  api.get('/reports/consultant-days', {
    params: { employeeId, from: fromIso, to: toIso },
  });

// TC-S3 — getDayDetail retired. The consultant panel now drills via
// getConsultantDays (TC-S2) and task titles route to the audit drawer
// via getWorkItemAudit in deliveryApi.js.

const reportsApi = {
  getAllProjectsReview, getProjectBreakdown, getProjectTasksReview,
  getProjectConsumption, projectConsumptionXlsxUrl,
  getTeamUtilization, getTeamCalendar, getTeamCalendarRange,
  getConsultantCalendar, getConsultantDays,
};
export default reportsApi;
